import { http } from "shared/api/http";
import { IOrganization, IOrganizationMetadata } from "./models";

const basePath = `${process.env.REACT_APP_API_BASE_URL}/api/v1`;

export const getOrganizationsByAuth0OrgId = async (auth0OrgId: string) => {

  const response = await http.get<IOrganization[]>(
    `${basePath}/organizations/auth0/${auth0OrgId}`
  );
  return response.data;
};

export const getOrganizationsByTenantId = async (tenantId: string) => {

  const response = await http.get<IOrganization[]>(
    `${basePath}/tenants/${tenantId}/organizations`
  );
  return response.data;
};

export const createOrganization = async (
  tenantId: string,
  data: { name: string; description?: string; projectPrefix?: string }
) => {
  const response = await http.post<IOrganization>(
    `${basePath}/tenants/${tenantId}/organizations`,
    data
  );
  return response.data;
};

export const updateOrganizationMetadata = async (
  tenantId: string,
  organizationId: string,
  metadata: IOrganizationMetadata
) => {
  const { data } = await http.put<IOrganization>(
    `${basePath}/tenants/${tenantId}/organizations/${organizationId}`,
    { metadata }
  );
  return data;
};
